export const onFileOpen = (buffer: Buffer, type: string) => {
  window.open(URL.createObjectURL(new Blob([buffer], { type })));
};
